import { AxiosError, AxiosResponse } from "axios";
import React from "react";
import { Navigate } from "react-router-dom";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { Col, Container, Row } from "reactstrap";
import CategoryDetailsFC from "./CategoryDetailsFC";
import { Button } from "reactstrap";
import backBtn from "../../../../images/backArrow.svg";
import {
  CategoryDetails,
  categoryDetailsProps,
  categoryDetailsStateValues,
  postComments,
  Subcategory
} from "../../../../models/ClientPortalCategoriesDetails/CategoriesDetails";
import CorporateStructure from "./CorporateStructureFC";
import Service from "../../../../services";
import { BankUserContext } from "../../../../bankUserContext";
import { CLIENT_SCREEN_TYPES, RoutesEnum } from "../../../../utils/RoutesUtil";
import { catchError } from "../../../../utils/Utils";


class CategoriesDetailsRC extends React.Component<
  categoryDetailsProps,
  categoryDetailsStateValues
> {
  service = new Service();
  static contextType = BankUserContext;
  context: React.ContextType<typeof BankUserContext> | undefined;


  constructor(props: any) {
    super(props);
    this.state = {
      categoryDetails: null,
      redirection: false,
      textAreaDisable: false,
      clientcategorycomment: null,
      disableforsuperuser:false,
      showCorporateStructure: false,
      changeCorporateStructure: false,
      answeredCorporateStructure: null,
      CorporateStructureData: null,
      corporatestructureInitialValues: null,
    };
  }

  setRedirection = () => {
    this.setState({ redirection: true });
  };

  componentDidMount() {

   const { categoryId, clientProductId, screenType } = this.props;
    this.categoryDetails(categoryId, clientProductId, screenType);
    this.props.location?.state?.editable?this.setState({textAreaDisable:!this.props.location?.state?.editable}):this.setState({textAreaDisable:true})
    this.showCorporateStructure();
    this.getWelcomeQuestion();
  }

  

  categoryDetails = (categoryId: any, clientProductId: any, screenType:string|undefined) => {
    
    if(screenType?.toLowerCase() === CLIENT_SCREEN_TYPES.CLIENT_VIEW){
      this.service
      .getSubCategoriesByCategoriesId(categoryId, clientProductId)
      .then((response: AxiosResponse<CategoryDetails>) => {     
        this.setState({
          categoryDetails: response?.data
        });
      }).catch((error:AxiosError)=>{
        catchError(error,true);
      });
    }
    if(screenType?.toLowerCase() === CLIENT_SCREEN_TYPES.COMPLIANCE_VIEW){
        
      this.service
      .getcategoryDetails(categoryId, clientProductId)
      .then((response: AxiosResponse<CategoryDetails>) => {     
        this.setState({
          categoryDetails: response?.data,
          clientcategorycomment: response?.data?.categoryComment,
        });
      });
    }
   
  };
  commentsSave = (event: any) => {
    const postComments1: postComments = {
      questionarieCategoryId: this.props.categoryId,
      categoryComment: event.target.value,
      clientProductsId: this.props.clientProductId,
    };
    this.service.postCategoryComment(postComments1).then(() => {});
  };

  categoryCommentsChangeHandler = (event: any) => {
    this.setState({ clientcategorycomment: event.target.value?.trimStart() });
    // if (event) {
    //   this.setRedirection();
    // } else {
    //   this.setState({
    //     changeCorporateStructure: !this.state.changeCorporateStructure,
    //   });
    //   const { categoryId } = this.props;
    //   this.categoryDetails(categoryId, this.props?.clientProductId, this.props?.screenType);
    //   this.getWelcomeQuestion();
    // }

  };
  corporateChangeData = (redirect: boolean | null) => {
    if (redirect) {
      this.setRedirection();
    } else {
      this.setState({
        changeCorporateStructure: !this.state.changeCorporateStructure,
      });
      const { categoryId } = this.props;
      this.categoryDetails(categoryId, this.props?.clientProductId, this.props?.screenType);
      this.getWelcomeQuestion();
    }
  };
  showCorporateStructure = () => {
    this.service.showCorporateStructure(this.props?.clientProductId,this.props.categoryId)
      .then((response: AxiosResponse<boolean>) => {
        if (response.data) {

          this.setState({ showCorporateStructure: response.data });
        }
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      });
  };
  getWelcomeQuestion = () => {
    this.service.getFirstQuestion(this.props?.clientProductId).then((response: any) => {
      if (response.data) {
        const questionAnswer =
          response.data?.answers !== null
            ? response.data?.answers[0]?.answer
            : null;
        const questionAnsweredInt =
          response.data?.answers !== null
            ? response.data?.answers[0]?.optionId
            : null;
        const initialValues = {
          ["question_" + response.data.questionId.toString()]: questionAnswer,
        };
        const questionAnswered = response.data.options.find(
          (m: any) => m.value === questionAnsweredInt
        );
        this.setState({
          CorporateStructureData: response.data,
          corporatestructureInitialValues: initialValues,
          answeredCorporateStructure: questionAnswered,
        });
      }
    });
  };

  render() {
    const { redirection } = this.state;
    if (redirection) {
      return <Navigate to={`/${RoutesEnum.CLIENT_QUESTIONARIE}/${this.props?.screenType}/${this.props.location.state?.clientId}/${this.props?.clientProductId}`} state={this.props.location?.state}/>;
    }

    const { categoryId } = this.props;
    return (
      <Container fluid className="CategoryDetailspage p-5">
        <Row className="CatCommentsBox">
          {this.props?.screenType?.toLowerCase() === CLIENT_SCREEN_TYPES.COMPLIANCE_VIEW && <Col className="d-flex flex-row justify-content-end">
            <div className="cateogryCompletionGrapWrapper">
              <div className="d-flex flex-column justify-content-center cateogryCompletionContainer">
                <h1 className="categoryData">Category{"\n"}</h1>
                <span className="completion">Completion</span>
              </div>
              <div
                style={{ width: 59.4, height: 59.4 }}
                className="m-2"
              >
                <CircularProgressbar
                  strokeWidth={14}
                  value={
                    this.state.categoryDetails
                      ?.parentCategoeryCompletedPercentage === undefined
                      ? 0
                      : this.state.categoryDetails
                          ?.parentCategoeryCompletedPercentage
                  }
                  text={`${
                    this.state.categoryDetails
                      ?.parentCategoeryCompletedPercentage === undefined
                      ? 0
                      : this.state.categoryDetails
                          ?.parentCategoeryCompletedPercentage
                  }%`}
                  styles={buildStyles({
                    // Rotation of path and trail, in number of turns (0-1)
                    // rotation: 0.25,

                    // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                    // strokeLinecap: "butt",

                    // Text size
                    textSize: "24px",

                    // How long animation takes to go from one percentage to another, in seconds
                    pathTransitionDuration: 2.0,

                    // Can specify path transition in more detail, or remove it entirely
                    // pathTransition: 'none',

                    // Colors
                    pathColor: `rgba(0,0,0,0.2, ${
                      this.state.categoryDetails
                        ?.parentCategoeryCompletedPercentage / 100
                    })`,
                    textColor: "#0C2240",
                    trailColor: "rgb(235 235 235)",
                    backgroundColor: "#0C2240",
                  })}
                />
                
              </div>
            </div>
            <div className="categoryCommentsWrap">
              <h1 className="categoryComments">Category Comments</h1>
              <textarea
                value={this.state.clientcategorycomment}
                onBlur={this.commentsSave}
                onChange={this.categoryCommentsChangeHandler}
                disabled={this.state.textAreaDisable}
              />
            </div>
          </Col>}
        </Row>
        <Row>
          <Col>
            <Button className="backBtn mybackbtn" onClick={this.setRedirection}>
              <img src={backBtn} alt="back" />
              <span className="Pageheading">Application Overview</span>
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <div>
              <div className="CategoryPageheadingContainer">
                <h1 className="CategoryPageHeading">
                  {this.state.categoryDetails?.name}
                </h1>
                <p className="categoryPageDesc">
                  {this.state.categoryDetails?.description}
                </p>
                  

                {this.state?.categoryDetails?.status && this.state?.categoryDetails?.status.toLowerCase() == "application in progress" ?
                
                  this.state.showCorporateStructure && !this.state.changeCorporateStructure && (
                    <div className="organizationcontainer">
                      <p className="corporate-structure">
                        Corporate Structure:
                      </p>
                      <p className="corporate-structure">
                        {this.state?.answeredCorporateStructure?.text}
                      </p>
                      <p
                        className="change"
                        onClick={() => this.corporateChangeData(false)}
                      >
                        Change
                      </p>
                    </div>
                  ) :<></>}
                  {this.state.changeCorporateStructure && (
                  <div>
                    <CorporateStructure
                      changeData={this.corporateChangeData}
                      corporateQuestionData={this.state.CorporateStructureData}
                      corporatestructureInitialValues={
                        this.state.corporatestructureInitialValues
                      }
                      clientProductId={this.props?.clientProductId}
                      clientId={this.context?.clientId}
                    />
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
        <Row className="categoryCardRow">
          {this.state?.categoryDetails?.subcategories !== undefined && !this.state.changeCorporateStructure 
            ? (this.state?.categoryDetails?.subcategories).map(
                (categoryCard: Subcategory) => (
                  <>
                    <Col
                      md="6"
                      className="categoryCardCol"
                      key={categoryCard.questionnarieSubcategoryId}
                    >
                      <CategoryDetailsFC
                        categoryCard={categoryCard}
                        categoryId={categoryId}
                        clientId={this.props.clientProductId}
                        screenType={this.props.screenType}
                      />
                    </Col>
                  </>
                )
              )
            : ""}
        </Row>
      </Container>
    );
  }
}

export default CategoriesDetailsRC;
